module.exports = __webpack_public_path__ + "img/checkedItem.d6c8963c.jpg";